export default "__VITE_ASSET__CNVRT68W__"